export default {
  // isLoggedIn: !!sessionStorage.getItem("token"),
  isLoggedIn: false,
  loading: false,
  token: !!sessionStorage.getItem("token"),
  layoutConfig: null,
  // {
  //   backgroundColor: "white",
  //   footerColor: "white",
  //   footerBackgroundColor: "black",
  //   footerFontSize: "24px",
  //   logo: "/logo.png",
  //   navbarBackgroundColor: "black",
  //   title: "QMS - WebReservation",
  //   titleColor: "white",
  //   titleSize: "28px"
  // },
  key: 1
};
